module.exports = __webpack_public_path__ + "img/tw.6f17da0a.svg";